<template>
<div>
  <div class="G_page">
    <div class="p7_company_header">
        <!-- <div class="p7_header_item">DGnet</div> -->
      <img @click.prevent="gotoHome" class="p7_logo p7_header_item" src="/dynamic/images/placeholder.png">
      <div class="p7_company_name"></div>
    </div>
    <div class='p7_buttons_container'>
      <button class="G_button2 p7_btn_1 p7_passwordless_select_btn" @click.prevent="loginType = 'passwordlessLogin'"></button>
      <button class="G_button2 p7_btn_1 p7_password_select_btn" @click.prevent="loginType = 'emailPasswordLogin'"></button>
      <button class="G_button2 p7_btn_1 p7_create_account_btn" @click.prevent="createNewUser"></button>
    </div>
      <!-- --------------------------------------------  Modals --------------------------------- -->
      <div class="G_box p7_login_modal">
        <div class=" p7_login_form_container" v-if="loginType === 'passwordlessLogin'">
          <form>
          <h2 class="p7_modal_header p7_passwordless_modal_header"></h2>
            <input v-on:keydown.13="passwordlessSignIn" class="p7_input" type="text" v-model.trim="email" placeholder="Email">
            <input class="G_hidden_element" type="text">
            <label v-if="emailError" class="p7_error_text p7_bad_email_error"></label>
          </form>
          <button class="p7_send_sign_in_email_btn" @click="passwordlessSignIn"></button>
        </div>

        <div class="p7_box p7_login_form_container" v-if="loginType === 'emailPasswordLogin'">
          <form>
          <h2 class="p7_modal_header p7_password_modal_header"></h2>
            <input class="p7_input" type="text" v-model.trim="email" placeholder="Email">
            <label v-if="emailError" class="p7_error_text p7_bad_email_error"></label>
            <br>
            <input v-on:keydown.13="passwordSignIn" class="p7_input" type="password" v-model.trim="password" placeholder="Password">
            <label v-if="passwordError" class="p7_error_text p7_bad_password_error"></label>
          </form>
            <div>
              <button class="p7_password_login_btn" @click="passwordSignIn"></button>
              <button class="p7_reset_password_btn" @click="resetPassword"></button>
            </div>
        </div>

        <div class="p70_box p7_login_form_container" v-if="loginType === 'createUser'">
          <form>
          <h2 class="p7_modal_header p7_create_user_header"></h2>
            <input class="p7_input" type="text" v-model.trim="email" placeholder="Email">
            <label v-if="emailError" class="p7_error_text p7_bad_email_error"></label>
            <br>
            <input class="p7_input" v-on:keyup.13="createAccount" type="password" v-model.trim="password" placeholder="Password">
            <label v-if="passwordError" class="p7_error_text p7_bad_password_error"></label>
          </form>
            <div>
              <button class="p7_create_user_btn G_button" @click.prevent="createAccount"></button>
            </div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import AWN from "awesome-notifications"
import base_i3_log from '../../watchdog_includes/base_i3_logging'
import { CR, RC } from '../../watchdog_includes/base_i2_success_codes'
import { setTimeout } from 'timers';

export default {
  name: "p7FirebaseLogin",
  data() {
    return {
      email: '',
      password: '',
      emailError: false,
      passwordError: false,
      loginType: "passwordlessLogin",
      loadingFlag: false
    };
  },
  components:{
  },
  computed: {
  },
  methods: {
    gotoHome: function() {
      window.vue_instance.$router.push('/');
    },
    createAccount: function() {
      var call_result = {};
      var debug_data = [];
      window.G_firebase_auth.bi5CreateUser(this.email.toLowerCase(),this.password)
    },
    resetPassword: function() {
       window.G_firebase_auth.bi5ResetPassword(this.email.toLowerCase())
    },
    passwordSignIn: function() {
      window.G_firebase_auth.bi5AttemptPasswordSignIn(this.email.toLowerCase(), this.password)
      return false;
    },
    passwordlessSignIn: function() {
      window.G_firebase_auth.bi5AttemptPasswordlessSignIn(this.email.toLowerCase())
      return false;
    },
    createNewUser: function() {
      this.loginType = 'createUser'
    },
    signingInFeedback: function() {
      this.loadingFlag = true 
      let notification = 'Loading Account Information.'
      this.$store.commit('updateNotifications', notification)
      this.$awn.info(notification)
      this.loadingFlag = true 
      // alert("token is being verified")
    },
    signedInCallback: function() {
      this.loadingFlag = false
      if(window.G_redirectUrl !== null) {
        //copy the simple object string into a new variable and delete the redirect, this way if the replace fails they aren't in an inifite loop
        var redirectUrl = window.G_redirectUrl;
        window.G_redirectUrl = null;
        window.vue_instance.$router.push(redirectUrl);

      // this will prevent redirecting if user logged in using email link.
      } else if (window.location.search !== null && 
                 window.location.search !== "" && 
                 window.location.search.indexOf('apiKey') < 0 &&
                 window.location.pathname.toLowerCase().indexOf('/automatic_user_creation/') < 0) {
        // Extracting redirect path from query string
        var redirect_to = decodeURIComponent(window.location.search).split("=")[1]
        window.vue_instance.$router.replace(redirect_to);
      } else {
        window.vue_instance.$router.replace("/dashboard");
      }

    },
    passwordlessEmailSent: function() {
      let notification = 'You should receive a sign in link in your email shortly.'
      this.$store.commit('updateNotifications', notification)
      this.$awn.info(notification)
      // alert("You should receive a sign in link in your email shortly")
    },
    passwordlessEmailSendFailed: function(error) {
      //alert("Error sending email:" + error)
    },
    emailValid: function() {
      this.emailError = false
    },
    emailNotValid: function() {
      this.emailError = true
    },
    signInFailedCallback: function(error) {
      this.loadingFlag = false
      if (error[0].code === 'auth/user-not-found'){
        let notification = 'User does not exist. Please create an account.'
        this.$store.commit('updateNotifications', notification)
        this.loginType = 'createUser'
        this.password = ''
        this.$awn.info(notification)
      }
      if (error[0].code === 'auth/wrong-password'){
        let notification = 'Incorrect password. Please try again.'
        this.password = ''
        this.$awn.info(notification)
      }
        
      // alert("sign in failed with error:" + JSON.stringify(error))
    },
    passwordNotValid: function() {
      this.passwordError = true
    },
    passwordValid: function() {
      this.passwordError = false
    },
    createUserFailed: function(error) {
      alert("create user failed with error:" + JSON.stringify(error))
    },
     passwordResetSent: function() {
      let notification = 'You should receive a password reset email shortly.'
      this.$store.commit('updateNotifications', notification)
      this.$awn.info(notification)
    },
     passwordResetFailed: function() {
      alert("password reset failed with errorr:" + JSON.stringify(error))
    },
    automaticUserCreation: function() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "p7login:automaticUserCreation ";
      var task_id = "p7login:automaticUserCreation";
      var base64_email_address = this.$route.params['newUserEmail'];
      var base64_password = this.$route.params['newUserPassword'];
      if(typeof base64_email_address !== 'string' || typeof base64_password !== 'string') {
        return;
      }
      this.password = base64_password
      try {
      this.email = atob(base64_email_address)
      } catch(error) {
        return_msg += "failed to convert base64 encoded strings with error:" + JSON.stringify(error);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return;
      }
      var date_object = new Date();
      window.G_firebase_auth.bi5CreateUser(this.email.toLowerCase(),this.password);
    },
  },
  mounted: function() {
    this.$nextTick(function() {
      window.G_firebase_auth.bi5SetLoginPageCallbacks(
        this.signingInFeedback,
        this.signedInCallback,
        this.signInFailedCallback,
        this.passwordlessEmailSent,
        this.passwordlessEmailSendFailed,
        this.emailValid,
        this.emailNotValid,
        this.passwordValid,
        this.passwordNotValid,
        this.createUserFailed,
        this.passwordResetSent,
        this.passwordResetFailed
      );
      //if the user is already signed in skip the login screen
      if(window.G_firebase_auth.IV_token_verified === true && window.G_firebase_auth.IV_is_guest === false) {
        this.signedInCallback();
        return;
      }
      //if the user was signing out reset the signout requested flag
      if (window.G_firebase_auth.IV_signout_requested_flag === true) {
        window.G_firebase_auth.IV_signout_requested_flag = false;
      }
      if( 'newUserEmail' in this.$route.params && 'newUserPassword' in this.$route.params) {
        //the 2 second delay is to allow time for firebase to auth with an existing account, so that an attempt isn't made to recreate an account
        setTimeout(this.automaticUserCreation,2000); 
      }
    })
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/public/p7Login.vue